import React from 'react';
import Bodentemperatur from '../components/Bodentemperatur';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodentemperaturUnterpullendorf() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodentemperatur-unterpullendorf-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodentemperatur-unterpullendorf-heading">BODENTEMPERATUR</h1>
        </div>

        <Bodentemperatur ort="unterpullendorf" />
      </div>
    </div>
  );
}

export default BodentemperaturUnterpullendorf;
